import React from "react";
import OverlayChart from "./OverlayChart";
import "./Charts.css";

export default function Charts({
  csvData,
  onLoadingStateChange,
  bessMaxCapacity,
  evMaxCapacity,
  deviceNames,
  proddeviceNames,
  hoveredSummaryCardTitle,
  summaryCardVisibility,
  summaryCardToggleRequest,
  onSummaryCardVisibilityChange,
  summaryHeader,
  dailyDemand,
  hasDemandCharge,
}) {
  return (
    <div className="charts-container">
      <OverlayChart
        csvData={csvData}
        onLoadingStateChange={onLoadingStateChange}
        deviceNames={deviceNames}
        proddeviceNames={proddeviceNames}
        bessMaxCapacity={bessMaxCapacity}
        evMaxCapacity={evMaxCapacity}
        hoveredSummaryCardTitle={hoveredSummaryCardTitle}
        summaryCardVisibility={summaryCardVisibility}
        summaryCardToggleRequest={summaryCardToggleRequest}
        onSummaryCardVisibilityChange={onSummaryCardVisibilityChange}
        summaryHeader={summaryHeader}
        dailyDemand={dailyDemand}
        hasDemandCharge={hasDemandCharge}
      />
    </div>
  );
}
